import { Box, Stack, Typography } from "@mui/material";
import { useState } from "react";
import HtmlPreview, { ARTICLE_FONT_SCALE } from "@entrilia/shared/components/html/HtmlPreview";
import type { InvestorCommunication } from "../../api/types/investorCommunicationsTypes";
import NewsArticleReadTracker from "./NewsArticleReadTracker";
import NewsItemMeta from "./NewsItemMeta";

interface Props {
  newsItem: InvestorCommunication;
  documentViewSessionId?: string;
  scrollContainer: HTMLElement | null;
  pageContent: HTMLElement | null;
}

const NewsDetailsArticleContent = ({ newsItem, documentViewSessionId, scrollContainer, pageContent }: Props) => {
  const [articleBody, setArticleBody] = useState<HTMLDivElement | null>(null);

  const heroImageUrl = newsItem.articleContent?.heroImageUrl;
  const htmlBody = newsItem.articleContent?.htmlBody;

  return (
    <Stack spacing={2.5} sx={{ width: "100%" }}>
      {heroImageUrl && (
        <Box component="img" src={heroImageUrl} alt="" sx={{ width: "100%", height: "auto", borderRadius: 1 }} />
      )}
      <Typography variant="h2">{newsItem.title}</Typography>
      <NewsItemMeta publishedAt={newsItem.publishedAt} categories={newsItem.categories} status={newsItem.status} />
      {htmlBody && (
        <HtmlPreview htmlContent={htmlBody} fontScale={ARTICLE_FONT_SCALE} containerProps={{ ref: setArticleBody }} />
      )}
      {documentViewSessionId && (
        <NewsArticleReadTracker
          sessionId={documentViewSessionId}
          scrollContainer={scrollContainer}
          pageContent={pageContent}
          articleBody={articleBody}
        />
      )}
    </Stack>
  );
};

export default NewsDetailsArticleContent;
